import React, { useState, useEffect } from 'react';
import { updateBook, getBookById } from './_request';
import { useAuth } from '../../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { IMAGE_URL } from '../../constants/Consts';
import pdf from '../../../assets/icons/pdf.svg'
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
const EditBook = () => {
    const location = useLocation();
    const { bookId } = location.state;
    const [bookData, setBookData] = useState({
        bookName: '',
        writerName: '',
        imageBase64: '',
        publishYear: '',
        totalBooks: '',
        bookVersion: '',
        publisherName: '',
        pdfBase64: ''
    });
    const { authToken } = useAuth();
    const navigate = useNavigate();
    const IMAGE_SHOW = `${IMAGE_URL}matbuaatImages`;
    const PDF_SHOW = `${IMAGE_URL}matbuaatPdf`;
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const fetchBook = async () => {
            try {
                const response = await getBookById(authToken, bookId);
                if (response && response.Book) {
                    setBookData({
                        bookName: response.Book.bookName,
                        writerName: response.Book.writerName,
                        imageBase64: response.Book.image, 
                        publishYear: response.Book.publishYear,
                        totalBooks: response.Book.totalBooks,
                        bookVersion: response.Book.bookVersion,
                        publisherName: response.Book.publisherName,
                        pdfBase64: response.Book.pdf 
                    });
                }
            } catch (error) {
                console.error('Error fetching book data:', error);
            }
        };
        fetchBook();
    }, [bookId, authToken]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setBookData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const base64String = await fileToBase64(file);
                setBookData(prevState => ({ ...prevState, imageBase64: base64String }));
            } catch (error) {
                console.error('Error converting image to Base64:', error);
            }
        }
    };

    const handlePdfUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const base64String = await fileToBase64(file);
                setBookData(prevState => ({ ...prevState, pdfBase64: base64String }));
            } catch (error) {
                console.error('Error converting PDF to Base64:', error);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const response = await updateBook(authToken, bookId, bookData);
            if (response.Result) {
                alert('Book Updated Successfully');
                navigate('/books');
            }
        } catch (error) {
            console.error('Error updating book:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">Create New Book</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Book Name
                    </label>
                    <input
                        type="text"
                        name="bookName"
                        value={bookData.bookName}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Writer Name
                    </label>
                    <input
                        type="text"
                        name="writerName"
                        value={bookData.writerName}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Book Image
                    </label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Publish Year
                    </label>
                    <input
                        type="text"
                        name="publishYear"
                        value={bookData.publishYear}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Total Books
                    </label>
                    <input
                        type="text"
                        name="totalBooks"
                        value={bookData.totalBooks}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Book Version
                    </label>
                    <input
                        type="text"
                        name="bookVersion"
                        value={bookData.bookVersion}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Publisher Name
                    </label>
                    <input
                        type="text"
                        name="publisherName"
                        value={bookData.publisherName}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Upload PDF
                    </label>
                    <input
                        type="file"
                        accept=".pdf"
                        onChange={handlePdfUpload}
                        className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                </div>
                {bookData.pdfBase64 && (
    <div className="mt-4">
        {bookData.pdfBase64.startsWith('data:application/pdf') ? (
            <a
                href={bookData.pdfBase64}
                download={`${bookData.bookName}.pdf`}
                className="text-blue-500 underline"
            >
             <img src={pdf} alt="" className='size-7'/>   Download PDF
            </a>
        ) : (
            <a
                href={`${PDF_SHOW}/${bookData.pdfBase64}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline flex align-middle gap-2"
            >
               <img src={pdf} alt="" className='size-7'/>  View PDF
            </a>
        )}
    </div>
)}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={20} color="inherit" /> : 'Update Book'}
                </Button>
            </form>

            {bookData.imageBase64 && (
                <div className="mt-6">
                    <h3 className="text-lg font-medium text-gray-700 mb-2">Image Preview</h3>
                    <img
                        src={bookData.imageBase64.startsWith('data:image') ? bookData.imageBase64 : `${IMAGE_SHOW}/${bookData.imageBase64}`}
                        alt="Book preview"
                        className="max-w-xs rounded-md shadow-sm"
                    />
                </div>
            )}
            
        </div>
    );
};

export default EditBook;
